import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home-outline",
  "use": "home-outline-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home-outline\"><path d=\"M10.5 15.5v-3.089l-.031-.084a3.565 3.565 0 0 0-.554-.957c-.532-.669-1.176-1.008-1.915-1.008-.739 0-1.383.339-1.915 1.008a3.58 3.58 0 0 0-.554.956l-.031.085V15.5h-5V6.25L8 .625l7.5 5.625v9.25h-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/home-outline.svg
// module id = 590
// module chunks = 0